<div class="inner-popup">
  <h2 mat-dialog-title style="font-weight: bold;">Days below threshold</h2>
  <button mat-button mat-dialog-close><mat-icon>{{ "button.Close" | translate | async }}</mat-icon></button>
</div>
<mat-dialog-content>
  <!-- {{occurrenceForm.value|json}} -->
  <!-- <app-error-message *ngIf="status === 'error'" [heading]="displayableServerError?.title"
    [message]="displayableServerError?.message"></app-error-message> -->
  <form id="occurrence" autocomplete="off" >
    <div class="items-heading">
      <h5  class="itemsheading" >Date</h5>
      <h5 class="itemsheading" 
   >Time Slots</h5>
      <h5 class="itemsheading" 
   >Gross Queue Capacity</h5>
      <h5 class="itemsheading">Queue Registration</h5>
    <h5 class="itemsheading">Utilization</h5>
    </div>
   
      <div  style="height: auto;">
        <div style="">
          <div style="margin-bottom: 7px;"></div>
          <div  class="items-heading" *ngFor="let data of this.data.dataSource.dataItems" >
          
             <div class="itemsheading2">
              {{data.alertDate}}
             </div>
             <div class="itemsheading2">
              {{data.grossQueueCapacity}}
             </div>
               <div class="itemsheading2">
              {{data.queueRegistrations}}
             </div>
               <div class="itemsheading2">
              {{data.timeSlot}}
             </div>
               <div class="itemsheading2">
              {{data.utilzation}}
             </div>
          
            
           
          </div>
          </div>
        </div>
        <div  style="justify-content: center;
    color: grey;
    font-family: sans-serif;
    margin: 18px;
    display: flex;" *ngIf="this.data.dataSource.dataItems == null">
          No Days available to display
        </div>
  
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="demoAction">
  <vue-flat-button (click)="closed()"
    >ok</vue-flat-button>
</mat-dialog-actions>
    
